'use client'

import { useEffect } from 'react'
import { useAppContext } from '@/app/_lib/_context'

/**
 * ActiveCategoryTracker - Sets the active category tree in context for main nav highlighting
 *
 * This component should be included in category and product pages to enable
 * the main navigation to highlight the appropriate menu item based on the
 * current page's category hierarchy.
 *
 * @param {Array} categoryTree - Array of category IDs representing the path from root to current category
 */
const ActiveCategoryTracker = ({ categoryTree }) => {
    const { setActiveCategoryTree } = useAppContext()

    useEffect(() => {
        if (categoryTree && Array.isArray(categoryTree)) {
            setActiveCategoryTree(categoryTree)
        }

        // Clear the category tree when component unmounts (navigating away)
        return () => {
            setActiveCategoryTree([])
        }
    }, [categoryTree, setActiveCategoryTree])

    // This component doesn't render anything
    return null
}

export default ActiveCategoryTracker
